import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    root: {
      "& .MuiPaper-root": {
        width: 420,
        padding: "32px 24px",
        boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.25)",
        borderRadius: "16px"
      }
    },
    title: {
      color: theme.palette.grey["900"],
      marginBottom: 40,
      whiteSpace: "pre-line",
      fontSize: 20
    }
  }),
  { name: "ConfirmModal" }
);
export default useStyles;
